var buyModule = {
    formTexts: {
        placement: {
            free: 'Со свободной рассадкой',
            choice: 'С выбором мест'
        }
    },
    init: function () {
        this.initOfflineBuyForm();
        this.initOnlineBuyForm();
        this.initFormOpeners();
        this.initGetActionCatch();
        this.checkForReadyForm();
    },
    renderTicketsCountSelect: function (bFormOptions) {
        var maxTicketsCount = window.php.maxTicketsInOrder;
        var selectStr = '<select name="amount" class="custom-select">';
        for (i = 1; i <= maxTicketsCount; i++) {
            selectStr += '<option value="' + i + '">' + i + '</option>';
        }
        selectStr += '</select>';

        return selectStr;
    },
    renderTicketsChoseCodSec: function (bFormOptions) {
        // Определяем валюту для отображения цены
        let currency = '';
        if (window.priceMatrix && typeof window.priceMatrix.currency !== 'undefined') {
            currency = window.priceMatrix.currency;
        } else if (window.php && typeof window.php.currency !== 'undefined') {
            currency = window.php.currency;
        } else if (bFormOptions && typeof bFormOptions.currency !== 'undefined') {
            currency = bFormOptions.currency;
        }

        const uniqueSec = bFormOptions?.choseSectorSelectionWithFreeSeating?.uniqueSec || {};
        const totalSectors = Object.keys(uniqueSec).length;
        const maxTicketsCount = window.php.maxTicketsInOrder;
        let selectStr = '<div class="tickets-chose-cod-sec-wrap-select">';

        let hasAvailableSector = false;

        for (let key in uniqueSec) {
            const availableTickets = uniqueSec[key]['availableTickets'] || 0;
            const isSoldOut = uniqueSec[key]['isSoldOut'] || false;

            // Сектор недоступен по диапазону дат — отображаем "Sold Out" вместо селекта
            if (isSoldOut) {
                const soldOutPrice = uniqueSec[key]['PriceSell'] != null
                    ? `<div class="h4">${app.formatPriceRoubles(Number(uniqueSec[key]['PriceSell']), currency)}</div>`
                    : '';
                if (totalSectors === 1) {
                    selectStr += `<div class="tickets-chose-cod-sec-wrap-sector-name-and-select"><div class="tickets-chose-cod-sec-wrap-sector-name">${soldOutPrice}</div><div class="tickets-chose-cod-sec-select text-muted">Sold Out</div></div>`;
                    return selectStr + '</div>';
                }
                selectStr += `
                    <div class="tickets-chose-cod-sec-wrap-sector-name-and-select">
                        <div class="tickets-chose-cod-sec-wrap-sector-name">
                            <div class="h4">${uniqueSec[key]['name_sec']}</div>
                            ${soldOutPrice}
                        </div>
                        <div class="h5 text-muted">Sold Out</div>
                    </div>`;
                continue;
            }

            // Если билетов нет и секторов несколько — пропускаем этот сектор
            if (availableTickets <= 0 && totalSectors > 1) {
                continue;
            }

            // Если сектор один и нет билетов — выводим сообщение и выходим (без названия сектора)
            if (availableTickets <= 0 && totalSectors === 1) {
                selectStr += `<div class="tickets-chose-cod-sec-wrap-sector-name-and-select"><div class="tickets-chose-cod-sec-select">Нет билетов</div></div>`;
                return selectStr + '</div>';
            }

            hasAvailableSector = true;

            const priceSell = app.formatPriceRoubles(Number(uniqueSec[key]['PriceSell']), currency);
            const codeSec = parseInt(uniqueSec[key]['cod_sec']); // Преобразуем в число
            // Ограничиваем выбор максимум 6 и не больше доступного количества
            const maxAvailable = Math.min(maxTicketsCount, 6, availableTickets);

            // Если сектор один — не показываем название и цену
            if (totalSectors === 1) {
                selectStr += `<div class="tickets-chose-cod-sec-wrap-sector-name-and-select"><div class="tickets-chose-cod-sec-select"><select name="amount" class="custom-select" data-code_sec="${codeSec}">`;
            } else {
              const sectorOldPrice = uniqueSec[key]['oldPrice']
                ? app.formatPriceRoubles(Number(uniqueSec[key]['oldPrice']), currency)
                : null
              const sectorPriceDescription = uniqueSec[key]['priceDescription'] || null
              const descriptionHtml = sectorPriceDescription
                ? `<div class="h5 text-dark-grey">${sectorPriceDescription}</div>`
                : ''
              const oldPriceHtml = sectorOldPrice
                ? `<div class="h5 text-dark-grey text-decoration-line-through">${sectorOldPrice}</div>`
                : ''
              const discountPriceActivityDate = uniqueSec[key]['discountPriceActivityDate']
                ? `<div class="h6 text-dark-grey">${uniqueSec[key]['discountPriceActivityDate']}</div>`
                : ''
              selectStr += `
                  <div class="tickets-chose-cod-sec-wrap-sector-name-and-select">
                    <div class="tickets-chose-cod-sec-wrap-sector-name">
                      <div class="h4">
                        ${uniqueSec[key]['name_sec']}
                      </div>
                      <div>
                        ${descriptionHtml}
                        <div class="uk-flex uk-flex-bottom gap-4">
                          <div class="h4">
                            ${priceSell}
                          </div>
                          ${oldPriceHtml}
                        </div>
                      </div>
                      ${discountPriceActivityDate}
                    </div>
                    <div class="tickets-chose-cod-sec-select">
                      <select name="amount" class="custom-select" data-code_sec="${codeSec}">`;
            }

            // При 1 секторе начинаем с 1, иначе с 0
            const startValue = (totalSectors === 1) ? 1 : 0;
            for (let i = startValue; i <= maxAvailable; i++) {
                selectStr += `<option value=${i}>${i}</option>`;
            }
            selectStr += '</select></div></div>';
        }

        // Если все секторы были без билетов и их было несколько — возвращаем пустую строку
        if (!hasAvailableSector && totalSectors > 1) {
            return '';
        }

        selectStr += '</div>';

        return selectStr;
    },
    renderPlaceChoiceBtn: function () {
        return '<a href="#ticket-choose-modal" id="chooseModalOpener" class="btn btn-outline-secondary">Выбрать места</a>';
    },
    renderAddressFields: function () {
        var addressFieldsStr = '<div class="custom-input-wrapper">\n' +
            '                                            <input type="text" name="deliveryAddress[street]" required class="custom-input" placeholder="Адрес">\n' +
            '                                        </div>\n' +
            '                                        <div class="custom-input-wrapper">\n' +
            '                                            <input type="text" name="deliveryAddress[entrance]" required class="custom-input" placeholder="Подъезд">\n' +
            '                                        </div>\n' +
            '                                        <div class="custom-input-wrapper">\n' +
            '                                            <input type="text" name="deliveryAddress[floor]" required class="custom-input" placeholder="Этаж">\n' +
            '                                        </div>\n' +
            '                                        <div class="custom-input-wrapper">\n' +
            '                                            <input type="text" name="deliveryAddress[flat]" required class="custom-input" placeholder="Квартира, Офис">\n' +
            '                                        </div>';

        return addressFieldsStr;
    },
    renderMemberPlaceInfo: function (seat) {
        seat = typeof seat !== 'undefined' ? seat : {};
        if (Object.keys(seat).length == 0) {
            var placeInfoStr = '<div class="error-member-info">\n' +
                '                                                    <h4>Место не выбрано</h4>\n' +
                '                                                    <span class="error">выберите место</span>\n' +
                '                                                </div>';
            return placeInfoStr;
        }
        var placeInfoStr = '<p>';
        if (seat.name_sec) {
            placeInfoStr += '<span class="member-place-section">' + seat.name_sec + ', </span>';
        }

        if (seat.row) {
            placeInfoStr += '<span class="member-place-row">ряд: ' + seat.row + ', </span>';
        }

        if (seat.seat) {
            placeInfoStr += '<span class="member-place-seat">место: ' + seat.seat + '</span>';
        }
        placeInfoStr += '</p>';

        return placeInfoStr;
    },
    renderMemberCard: function (memberNum, isPlaceChoice, isAskAge, hideOptionalFields = false, courseMemberFields) {
        isPlaceChoice = typeof isPlaceChoice !== 'undefined' ? isPlaceChoice : false;
        memberNum = typeof memberNum !== 'undefined' ? memberNum : 1;
        isAskAge = typeof isAskAge !== 'undefined' ? isAskAge : false;
        var selectedPlaces = getCheckedPlaces();

        let userFirstName = '';
        let userLastName = '';
        let userEmail = '';
        let userBirthday = '';
        let userPhone = '';

        if(window?.jsConfig?.user?.data) {
           let userData = window.jsConfig.user.data;

           if (typeof userData === 'object' && userData !== null) {
               if (typeof userData.firstname !== 'undefined' && userData.firstname !== null && userData.firstname !== '') {
                   userFirstName = userData.firstname;
               }

               if (typeof userData.lastname !== 'undefined' && userData.lastname !== null && userData.lastname !== '') {
                   userLastName = userData.lastname;
               }

               if (typeof userData.email !== 'undefined' && userData.email !== null && userData.email !== '') {
                   userEmail = userData.email;
               }

               if (typeof userData.mobile !== 'undefined' && userData.mobile !== null && userData.mobile !== '') {
                   userPhone = '+' + userData.mobile;
               }
           }
        }

        let emailInput = '',
            phoneInput = '',
            birthdayInput = '',
            lastNameInput = '',
            firstNameInput = '';

        if (typeof courseMemberFields !== 'undefined' && courseMemberFields.length > 0 && courseMemberFields !== 'null') {
            let courseMemberFieldArray = JSON.parse(courseMemberFields);
            courseMemberFieldArray.forEach(function(elem) {
                if (elem.field === 'firstname') {
                    firstNameInput = '<div class="custom-input-wrapper">\n' +
                        '<input type="text" class="custom-input" value="'+ userFirstName +'" required name="membersData[' + memberNum + '][name]" placeholder="Имя">\n' +
                        '</div>\n'
                }

                if (elem.field === 'lastname') {
                    lastNameInput = '<div class="custom-input-wrapper">\n' +
                        '<input type="text" class="custom-input" value="'+ userLastName +'" required name="membersData[' + memberNum + '][lastname]" placeholder="Фамилия">\n' +
                        '</div>\n'
                }

                if (elem.field === 'email') {
                    emailInput = '<div class="custom-input-wrapper">\n' +
                        '<input type="email" value="'+ userEmail +'" name="membersData[' + memberNum + '][email]" required class="custom-input"\n' +
                        ' placeholder="Электронная почта">\n' +
                        ' </div>\n'
                }

                if (elem.field === 'mobile') {
                    phoneInput = '<div class="custom-input-wrapper">\n' +
                        '<input type="tel" value="'+ userPhone +'" class="custom-input new-phone-input" required name="membersData[' + memberNum + '][phone]">\n' +
                        '</div>\n';
                }

                if (elem.field === 'birthday') {
                    birthdayInput = '<div class="custom-input-datepicker-wrapper">\n' +
                        '<div class="custom-input-datepicker-item">\n' +
                        '<input type="text" readonly value="'+ userBirthday +'" ' +
                        'placeholder="Дата рождения" name="membersData[' + memberNum + '][birthday]" class="datepicker-init custom-input">\n' +
                        '<span class="datepicker-manual-handle"></span>\n' +
                        '</div>\n' +
                        '</div>';
                }
            });
        }


        var memberStr = '<div class="event-info-aside__buy-ticket__member custom-input-wrapper" data-num="' + memberNum + '">\n' +
            '                                            <header class="uk-clearfix">\n' +
            '                                                <div class="event-info-aside__buy-ticket__member-number">\n' +
            '                                                    <h4 class="">Билет <span class="member-num">№' + memberNum + '</span></h4>\n';
        memberStr += '<div class="member-placeInfo-wrap">';
        var thisSeat = {};
        if (selectedPlaces.length > 0) {
            var thisSeat = selectedPlaces[memberNum - 1];
        }
        if (isPlaceChoice) {
            var placeInfo = buyModule.renderMemberPlaceInfo(thisSeat);
        }

        if (placeInfo) {
            memberStr += placeInfo;
        }
        memberStr += '</div>';
        memberStr += '                                                </div>\n';
        if (!isAskAge || memberNum > 1) {
            memberStr += '                                                <div class="event-info-aside__buy-ticket__member-delete">\n' +
                '                                                    <a href="#" class="member-remove"><img src="' + app.options.assetsFolder + 'img/icons/close-blue-ico.svg"\n' +
                '                                                                             alt=""><span>удалить</span></a>\n';
        }
        memberStr += '                                       </div>\n' +
            '                                            </header>\n' +
                                                            firstNameInput +
                                                            lastNameInput +
                                                            birthdayInput +
                                                            emailInput +
                                                            phoneInput;

        memberStr += '                                        </div>';
        return memberStr;
    },
    renderPaymentOption: function (paymentOption) {
        const checked = paymentOption.default ? 'checked' : '';
        return `
            <label>
                <input class="uk-radio payment-option__radio" ${checked} type="radio" value="${paymentOption.code}" name="payment_option">
                ${paymentOption.title}
            </label>`;
    },
    renderPaymentOptionWarning: function (paymentOption) {
        return `
            <div class="payment-option-warning">
                <span class="error">${paymentOption.warning}</span>
            </div>`;
    },
    renderPriceMatrix: function (priceMatrix, $targetForm, formOptions, itemType) {
        formOptions = typeof formOptions !== 'undefined' ? formOptions : {};
        $targetForm = typeof $targetForm !== 'undefined' ? $targetForm : {};
        itemType = typeof itemType !== 'undefined' ? itemType : 'ticket';

        var pricesStr = "";
        var entityTitle = "билетов";

        if (itemType === 'course') {
            entityTitle = 'курса';
        } else if (itemType === 'video') {
            entityTitle = 'видео';
        } else if (itemType === 'stream') {
            entityTitle = 'трансляции';
        }

        let slideHeader = $targetForm.find('header.priceMatrixSlide');
        let currency = '';

        if (typeof priceMatrix.currency !== 'undefined') {
            currency = priceMatrix.currency;
        }

        if (typeof slideHeader !== 'undefined' && typeof priceMatrix.finalPrice !== 'undefined') {

            slideHeader.find('span:first-of-type').text(app.formatPriceRoubles(priceMatrix.finalPrice, currency));

            if (priceMatrix.itemCount !== 'undefined') {
                if (priceMatrix.itemCount > 1) {
                    $('.new-translation-form__little-label.access-count').text(`за ${priceMatrix.itemCount} доступа`);
                }
            }
        }

        if (Object.keys(priceMatrix).length == 0) {
            if ($targetForm.hasClass('.offline-ticket__form')) {
                pricesStr += '<span class="error warning">итоговая стоимость будет расчитана после выбора мест</span>';
            }
            return pricesStr;
        }

        if (priceMatrix.itemCount) {
            pricesStr += generatePriceHTML(
                itemType === 'ticket' ? '/resources/img/icons/about-tickets-ico.svg' : '/resources/img/icons/play-circle.svg',
                `Стоимость ${entityTitle}`,
                app.formatPriceRoubles(priceMatrix.originalPrice * priceMatrix.itemCount, currency)
            );
        } else if (priceMatrix.originalPrice && priceMatrix.originalPrice != priceMatrix.finalPrice) {
            pricesStr += generatePriceHTML(
                itemType === 'ticket' ? '/resources/img/icons/about-tickets-ico.svg' : '/resources/img/icons/play-circle.svg',
                `Стоимость ${entityTitle}`,
                app.formatPriceRoubles(priceMatrix.originalPrice, currency)
            );
        }

        if (priceMatrix.deliveryPrice) {
            pricesStr += `
                <div class="event-info-aside__buy-ticket__price-part delivery-price-part">
                    <p>${app.formatPriceRoubles(priceMatrix.deliveryPrice, currency)}</p>
                    <span class="__font-weight-300">Стоимость доставки</span>
                </div>`;
        }

        if (priceMatrix.originalMarginCost && priceMatrix.itemCount) {
            pricesStr += generatePriceHTML(
                '/resources/img/icons/percent-ico.svg',
                'Комиссия платёжной<br>системы',
                app.formatPriceRoubles(priceMatrix.originalMarginCost * priceMatrix.itemCount, currency)
            );
        } else if (priceMatrix.originalMarginCost) {
            pricesStr += generatePriceHTML(
                '/resources/img/icons/percent-ico.svg',
                'Комиссия платёжной<br>системы',
                app.formatPriceRoubles(priceMatrix.originalMarginCost, currency)
            );
        }

        // if (priceMatrix.promoDiscount) {
        //     pricesStr += '<div class="event-info-aside__buy-ticket__price-part fee-price-part uk-clearfix">\n' +
        //         '                                            <div class="totals-entry__itemname"><span class="totals-entry__itemname-percent-icon"></span></div>\n' +
        //         '                                                <div class=" price-value">- ' + app.formatPriceRoubles(priceMatrix.promoDiscount, currency) + '</div>\n' +
        //         '                                                <span class="totals-entry__itemname">Скидка по промокоду</span>\n' +
        //         '                                            </div>';
        // }

        let pricesStrAllSum = '';

        if (priceMatrix.marginCost && priceMatrix.itemCount) {
            pricesStrAllSum += generateFinalPriceHTML(
                app.formatPriceRoubles(priceMatrix.finalPrice + priceMatrix.marginCost, currency),
                priceMatrix.promoDiscount
                    ? app.formatPriceRoubles(priceMatrix.originalPrice * priceMatrix.itemCount + priceMatrix.originalMarginCost, currency)
                    : null,
                `Общая стоимость ${entityTitle}`
            );
        } else {
            pricesStrAllSum += generateFinalPriceHTML(
                app.formatPriceRoubles(priceMatrix.finalPrice, currency),
                priceMatrix.promoDiscount
                    ? app.formatPriceRoubles(priceMatrix.originalPrice + priceMatrix.originalMarginCost, currency)
                    : null,
                `Общая стоимость ${entityTitle}`
            );
        }

        return  {
            pricesStr: pricesStr,
            pricesStrAllSum: pricesStrAllSum,
        };

    },
    renumerateMemberCards: function ($memberCards) {
        if ($memberCards.length > 0) {
            $memberCards.each(function () {
                var num = $(this).index() + 1;
                $(this).attr('data-num', num);
                $(this).find('.member-num').text('№' + num);
            });
        }
    },

    recalculatePriceMatrix: function ($form, bFormPriceMatrix, promoCodeValue, bFormOptions) {
        bFormPriceMatrix = typeof bFormPriceMatrix !== 'undefined' ? bFormPriceMatrix : {};
        bFormOptions = typeof bFormOptions !== 'undefined' ? bFormOptions : {};
        promoCodeValue = typeof promoCodeValue !== 'undefined' ? promoCodeValue : false;

        var recalculateEndpoint = $form.attr('bFormCalculateEndpoint');
        var ajaxData = {};
        var placementType = $form.data('placement') ? $form.data('placement') : 'free';
        var itemId = $form.data('itemId');
        var itemType = bFormOptions.item.type;

        if (itemType == 'ticket') {
            var ticketsCount = $form.find('.tickets-count-select-wrap select').val();

            if ($form.find('.tickets-chose-cod-sec-wrap select').length) {
                var codSec = [];

                $('.tickets-chose-cod-sec-wrap select').each(function() {
                    var countTickets = $(this).val();
                    var codeSec = $(this).data('code_sec');
                    // Преобразуем в число и проверяем, что количество > 0
                    if (parseInt(countTickets) > 0 && codeSec) {
                        var obj = {
                            ['countTickets']: countTickets,
                            ['codeSec']: parseInt(codeSec), // Преобразуем в число
                        };

                        codSec.push(obj);
                    }
                });
                
                // Если для новой системы секторов билеты не выбраны, устанавливаем цену в 0
                if (bFormOptions?.usesSectorSystem && codSec.length === 0) {
                    var zeroPriceMatrix = {
                        finalPrice: 0,
                        originalPrice: 0,
                        marginCost: 0,
                        originalMarginCost: 0,
                        promoDiscount: 0,
                        currency: bFormPriceMatrix.currency || '',
                        itemCount: 0,
                    };
                    var priceMatrix = $(buyModule.renderPriceMatrix(zeroPriceMatrix, $form, bFormOptions, itemType));
                    var $priceMatrixWrap = $form.find('.priceMatrixWrap');
                    var $pricesStrAllSumWrapper = $form.find('.pricesStrAllSumWrapper');
                    if (priceMatrix && typeof priceMatrix === 'object' && priceMatrix.length > 0) {
                        $priceMatrixWrap.html(priceMatrix[0].pricesStr);
                        $pricesStrAllSumWrapper.html(priceMatrix[0].pricesStrAllSum);
                    }
                    return; // Не делаем запрос к серверу, если билеты не выбраны
                }
            }

            var paymentOptionCode = $('.payment-option__radio:checked').val();
            switch (placementType) {
                case 'free':
                    ajaxData = {
                        itemType: itemType,
                        itemId: itemId,
                        ticketsCount: ticketsCount,
                        paymentOption: paymentOptionCode,
                        items: [],
                        codSec: codSec,
                    };

                    for (i = 1; i <= ticketsCount; i++) {
                        ajaxData.items.push({
                            PriceSell: bFormPriceMatrix.originalPrice
                        });
                    }

                    if (promoCodeValue) {
                        ajaxData.promoCode = promoCodeValue;
                    }

                    break;
                case 'choice':
                    ajaxData = {
                        itemType: itemType,
                        itemId: itemId,
                        ticketsCount: ticketsCount,
                        paymentOption: paymentOptionCode,
                        items: []
                    };

                    var selectedPlaces = getCheckedPlaces();
                    var selectedPlacesCount = selectedPlaces.length;
                    if (selectedPlacesCount > 0) {
                        selectedPlaces.forEach((place) => {
                            ajaxData.items.push({
                                PriceSell: place.PriceSell,
                                row: place.row,
                                seat: place.seat,
                                cod_sec: place.cod_sec
                            });
                        });
                    }

                    if (promoCodeValue) {
                        ajaxData.promoCode = promoCodeValue;
                    }
                    break;
            }
        } else {
            ajaxData = {
                itemType: itemType,
                itemId: itemId,
                items: []
            };
            var selectedBuyOptionCode = false;
            var itemPrice = false;

            if ($form.find('.buy-options-select__inform').length > 0) {
                selectedBuyOptionCode = $form.find('.buy-options-select__inform').val();
                var buyOptionFound = bFormOptions.item.buyOptions.filter(obj => {
                    return obj.code === selectedBuyOptionCode
                })[0];
                itemPrice = buyOptionFound.price;
            } else {
                itemPrice = bFormPriceMatrix.originalPrice;
            }

            ajaxData.itemsCount = ($form.find('input#isGift0').is(':checked') ? 1 : 0) + ($form.find('input#isGift1').is(':checked') ? 1 : 0);

            ajaxData.items.push({
                PriceSell: itemPrice
            });

            if (promoCodeValue) {
                ajaxData.promoCode = promoCodeValue;
            }
        }

        $.ajax({
            url: recalculateEndpoint,
            method: 'POST',
            dataType: 'json',
            data: ajaxData,
            success: function (response) {
                const $priceMatrixWrap = $form.find('.priceMatrixWrap');
                const $pricesStrAllSumWrapper = $form.find('.pricesStrAllSumWrapper');

                // Если priceMatrix отсутствует или пуст, очищаем блоки и выходим
                if (!response || !response.priceMatrix) {
                    $priceMatrixWrap.html('');
                    $pricesStrAllSumWrapper.html('');
                } else {
                    const renderedPriceMatrix = buyModule.renderPriceMatrix(response.priceMatrix, $form, bFormOptions, itemType);
                    const priceMatrix = $(renderedPriceMatrix);

                    if (priceMatrix && priceMatrix[0]) {
                        $priceMatrixWrap.html(priceMatrix[0].pricesStr ?? '');
                        $pricesStrAllSumWrapper.html(priceMatrix[0].pricesStrAllSum ?? '');
                    } else {
                        $priceMatrixWrap.html('');
                        $pricesStrAllSumWrapper.html('');
                    }
                }

                if (Object.keys(response.promoCode).length > 0) {
                    const promoCodeObj = response.promoCode;

                    switch (promoCodeObj.valid) {
                        case true:
                            buyModule.applyPromoCode($form, promoCodeValue);
                            break;
                        case false:
                            if (ajaxData.promoCode !== undefined) {
                                const errorMessage = promoCodeObj.message;
                                $form.find('.promocode-response-message')
                                    .addClass('promocode-response-message--error')
                                    .html(`
                                        <div class="payment-option-warning">
                                            <span class="error">${errorMessage}</span>
                                        </div>
                                    `);
                                break;
                            }
                    }
                }
            }
        });
    },
    currentLectureId: function () {
        return typeof php !== 'undefined' && php.lectureDetails ? php.lectureDetails.lectureId : null;
    },
    checkForReadyForm: function () {
        if (!app.isUserAuthorized()) {
            localStorage.clear();
            return;
        }
        if (localStorage.getItem('offline-buy-form')) {
            const $form = $('.offline-ticket__form');
            let formData = JSON.parse(localStorage.getItem('offline-buy-form'));

            // a form saved on another lecture is not restored here (forms saved before the lectureId was kept have none)
            if (formData.lectureId !== undefined && formData.lectureId !== buyModule.currentLectureId()) {
                localStorage.removeItem('offline-buy-form');

                return;
            }

            let soldMeanwhile = 0;
            if (formData.selectedPlaces.length > 0) {
                soldMeanwhile = setCheckedPlaces(formData.selectedPlaces);
            }

            $('.go-to-offline-ticket-form').click();

            $form.deserialize(formData.offlineForm);

            if (formData.isTicketsGifts) {
                $('.tickets-are-gift-checkbox').prop('checked', true).change();
            } else {
                $('.tickets-count-select-wrap select').trigger('change');
                $('.tickets-chose-cod-sec-wrap select').trigger('change');
            }

            $form.deserialize(formData.offlineForm);

            if (soldMeanwhile > 0) {
                // not submitted: the box office would refuse the order (KB-059), the buyer picks other places
                localStorage.removeItem('offline-buy-form');
                buyModule.setFormValidateErrors($form, [{
                    message: 'Часть выбранных мест уже продана. Выберите, пожалуйста, другие места.',
                }]);

                return;
            }

            let $button = $form.find('.js-offline-submit-pay-proceed');
            app.buttonStartLoading($button);

            $form.find('.hidden-buyform-submit').click();
            localStorage.clear();

        } else if (localStorage.getItem('online-buy-form-cart')) {
            let formData = JSON.parse(localStorage.getItem('online-buy-form-cart'));
            const params = new URLSearchParams(formData.onlineForm);
            const promoCode = params.get('promoCode');
            let $form = $('.online-ticket__form');
            let goToOnlineTicketForm = $('.go-to-online-ticket-form');
            $form.find('.js-online-submit-pay-proceed').hide();
            $form.deserialize(formData.onlineForm);
            $form.attr('action', $form.attr('bFormCartAction'));

            goToOnlineTicketForm.click();

            app.buttonStartLoading($('.js-online-submit-cart-add'));
            $('.js-online-submit-pay-proceed').addClass('btn-disabled');

            $form.find('.promoCode-input').val(promoCode);
            $form.find('.hidden-buyform-submit').click();

            localStorage.clear();
        } else if (localStorage.getItem('online-buy-form')) {
            let formData = JSON.parse(localStorage.getItem('online-buy-form'));
            let $form = $('.online-ticket__form')

            $form.deserialize(formData.onlineForm);
            $form.attr('action', $form.attr('bFormPayAction'));

            $('.go-to-online-ticket-form').click();

            app.buttonStartLoading($('.js-online-submit-pay-proceed'));
            $('.js-online-submit-cart-add').addClass('btn-disabled');

            $form.find('.hidden-buyform-submit').click();
            localStorage.clear();
        }

        let getGoToOfflineTicketForm = $('.go-to-offline-ticket-form');

        if (getGoToOfflineTicketForm.length > 0 && localStorage.getItem(app.localStorageGoToOfflineTicketFormKey) && app.isUserAuthorized()) {
            localStorage.removeItem(app.localStorageGoToOfflineTicketFormKey);

            getGoToOfflineTicketForm.click();
        }
    },
    initGetActionCatch: function () {
    },
    attachEventHandlers: function ($form, bFormOptions, bFormPriceMatrix) {
        bFormOptions = typeof bFormOptions !== 'undefined' ? bFormOptions : {};
        bFormPriceMatrix = typeof bFormPriceMatrix !== 'undefined' ? bFormPriceMatrix : {};
        $(document).on('submit', '.offline-ticket__form', function (e) {
            e.preventDefault();
            var $form = $(this);
            app.setFormLoadingState($form, true);
            let $button = $form.find('.js-offline-submit-pay-proceed');
            app.buttonStartLoading($button);
            var method = $form.attr('method');
            var formData = $form.serialize();
            var selectedPlacesArray = getCheckedPlaces();

            var validationResult = buyModule.validateOfflineForm($form, selectedPlacesArray, bFormOptions);
            if (validationResult.length > 0 || $('.offline-validation__error').length) {
                buyModule.setFormValidateErrors($form, validationResult);
                app.setFormLoadingState($form, false);
                app.buttonStopLoading($button);
                return false;
            }

            var selectedPlaces = $.param({selectedPlaces: selectedPlacesArray});
            var endpoint = $form.attr('action');
            var ajaxData = formData + '&' + selectedPlaces;

            var extraFormData = {};

            var paymentOptionCode = $form.find('.payment-option__radio:checked').val();
            var paymentOptionFound = bFormOptions.payment?.filter(obj => {
                return obj.code === paymentOptionCode
            })[0];

            if (paymentOptionFound && paymentOptionFound.requestAddress) {
                extraFormData.deliveryEnabled = true;
            }
            extraFormData.isFreeOfferSeat = bFormOptions.placement == 'free' ? 1 : 0;

            ajaxData = ajaxData + '&' + $.param(extraFormData);

            if ($form.find('.tickets-chose-cod-sec-wrap select').length) {
                var codSec = [];

                $('.tickets-chose-cod-sec-wrap select').each(function() {
                    var countTickets = $(this).val();
                    var codeSec = $(this).data('code_sec');
                    // Преобразуем в число и проверяем, что количество > 0
                    if (parseInt(countTickets) > 0 && codeSec) {
                        var obj = {
                            ['countTickets']: countTickets,
                            ['codeSec']: parseInt(codeSec), // Преобразуем в число
                        };

                        codSec.push(obj);
                    }
                });

                // Для новой системы секторов не отправляем запрос, если билеты не выбраны
                if (bFormOptions?.usesSectorSystem && codSec.length === 0) {
                    buyModule.setFormValidateErrors($form, [{message: 'Пожалуйста, выберите хотя бы один билет'}]);
                    app.setFormLoadingState($form, false);
                    app.buttonStopLoading($button);
                    return false;
                }

                var codSecString = JSON.stringify(codSec);

                ajaxData = ajaxData + '&codSec=' + encodeURIComponent(codSecString);
            }

            $.ajax({
                url: endpoint,
                method: method,
                data: ajaxData,
                dataType: 'json',
                success: function (response) {
                    switch (response.status) {
                        case 'success':
                            if (response.redirectUrl) {
                                location.href = response.redirectUrl;
                            } else if (response.cart) {
                                cartModule.updateHeaderCart(response.cart.count);
                                // do smth with cart info
                            }
                            break;
                        case 'error':
                            buyModule.setFormValidateErrors($form, response.errors);
                            app.buttonStopLoading($button);
                            break;
                    }

                    app.setFormLoadingState($form, false);
                },
                error: function() {
                    app.setFormLoadingState($form, false);
                    app.buttonStopLoading($button);
                }
            });
        });

        $(document).on('click', '.js-offline-submit-cart-add', function (e) {
            e.preventDefault();
            $form.attr('action', $form.attr('bFormCartAction'));
            app.buttonStartLoading(this);
            $form.find('.hidden-buyform-submit').click();
        });

        $(document).on('click', '.js-offline-submit-pay-proceed', function (e) {
            e.preventDefault();
            document.querySelectorAll('.isStripe').forEach(function (element) {
                element.value = 0;
            });
            $form.attr('action', $form.attr('bFormPayAction'));
            if (app.isUserAuthorized()) {
                $form.find('.hidden-buyform-submit').click();
            }
        });

        $(document).on('click', '.js-stripe-offline-submit-pay-proceed', function (e) {
            e.preventDefault();

            document.querySelectorAll('.isStripe').forEach(function (element) {
                element.value = 1;
            });
            $form.attr('action', $form.attr('bFormPayAction'));
            if (app.isUserAuthorized()) {
                $form.find('.hidden-buyform-submit').click();
            }
        });

        $form.on('change', '.tickets-are-gift-checkbox', function () {
            if ($(this).prop('checked')) {
                $('.are-gift-warn').show();
            } else {
                $('.are-gift-warn').hide();
            }

            app.reCheckSticky();
        });

        $form.on('click', '.member-remove', function (e) {
            e.preventDefault();
            var $memberParent = $(this).closest('.event-info-aside__buy-ticket__member');
            var thisMemberIndex = $memberParent.index();
            $memberParent.remove();
            var $memberCards = $form.find('.event-info-aside__buy-ticket__member');
            var membersCount = $memberCards.length;
            var selectedPlaces = getCheckedPlaces();
            var seatToUncheck = false;
            var removedMemberSeat = selectedPlaces[thisMemberIndex];
            if (removedMemberSeat) {
                seatToUncheck = removedMemberSeat.cell_id;
            }

            if (membersCount > 0) {
                var membersCount = $memberCards.length;
                $form.find('.tickets-count-select-wrap select').val(membersCount).trigger('change');
                buyModule.renumerateMemberCards($memberCards);
            } else {
                $form.find('.tickets-are-gift-checkbox').prop('checked', false);
                $form.find('.tickets-count-select-wrap select').val(1).trigger('change');
            }

            if (seatToUncheck) {
                $('.placeSeat').each(function () {
                    var sender = $(this).find('rect');

                    if (!sender.data('checked')) {
                        return;
                    }
                    if (sender.data('id') == seatToUncheck) {
                        $('.placeInfo').remove();

                        var d3Sender = d3.select(this).select('rect');

                        if (false === sender.data('checked')) {
                            sender.data('checked', true);
                        } else {
                            sender.data('checked', false);
                            $(sender).data('checked', false);
                        }

                        d3Sender.style('fill', '#' + php.schemaHallList[sender.data('id')].BackColor);
                    }

                });

                recalculateSelectedTicketPrice();
            }

        });

        $form.on('change', '.tickets-chose-cod-sec-wrap select', function () {
            var promoCodeValue = $form.find('.promoCode-input').val();
            var paymentOptionCode = $(this).val();
            var paymentOptionFound = bFormOptions.payment.filter(obj => {
                return obj.code === paymentOptionCode
            })[0];

            if (paymentOptionFound && paymentOptionFound.warning) {
                $form.find('.payment-option-warning-wrap').html($(buyModule.renderPaymentOptionWarning(paymentOptionFound)));
            } else {
                $form.find('.payment-option-warning-wrap').html('');
            }

            buyModule.recalculatePriceMatrix($form, bFormPriceMatrix, promoCodeValue, bFormOptions);
            app.reCheckSticky();
        });

        $form.on('change', '.tickets-count-select-wrap select', function () {
            var ticketsCount = $(this).val();
            var areGift = $('.tickets-are-gift-checkbox').is(':checked');
            var isAskAge = bFormOptions.isAskAge;

            var promoCodeValue = $form.find('.promoCode-input').val();
            $('.event-info-aside__buy-ticket__input-group > header > h3').text(getActualTicketFormHeader(ticketsCount));
            if (isAskAge) {
                var $membersWrap = $form.find('.event-info-aside__buy-ticket__members-wrapper');
                var $memberCards = $membersWrap.find('.event-info-aside__buy-ticket__member');
                var currentMembersCount = $memberCards.length;

                if (currentMembersCount < ticketsCount) {
                    for (i = currentMembersCount + 1; i <= ticketsCount; i++) {
                        $membersWrap.append($(buyModule.renderMemberCard(i, bFormOptions.placement === 'choice', isAskAge,false, bFormOptions.courseMemberFields)));
                    }
                    app.initNewPhoneInput();
                } else if (currentMembersCount > ticketsCount) {
                    var eqToRemove = parseInt(ticketsCount) - 1;
                    $memberCards.filter(':gt(' + eqToRemove + ')').each(function () {
                        var thisMemberIndex = $(this).index();
                        var membersCount = currentMembersCount;
                        var selectedPlaces = getCheckedPlaces();
                        var seatToUncheck = false;
                        var removedMemberSeat = selectedPlaces[thisMemberIndex];
                        if (removedMemberSeat) {
                            seatToUncheck = removedMemberSeat.cell_id;
                        }

                        if (seatToUncheck) {
                            $('.placeSeat').each(function () {
                                var sender = $(this).find('rect');

                                if (!sender.data('checked')) {
                                    return;
                                }
                                if (sender.data('id') == seatToUncheck) {
                                    $('.placeInfo').remove();

                                    var d3Sender = d3.select(this).select('rect');

                                    if (false === sender.data('checked')) {
                                        sender.data('checked', true);
                                    } else {
                                        sender.data('checked', false);
                                        $(sender).data('checked', false);
                                    }

                                    d3Sender.style('fill', '#' + php.schemaHallList[sender.data('id')].BackColor);
                                }

                            });

                            recalculateSelectedTicketPrice();
                        }
                        $(this).remove();
                    })
                }
            }
            if (bFormOptions.placement == 'free' || getSelectedTicketsCount() > 0) {
                buyModule.recalculatePriceMatrix($form, bFormPriceMatrix, promoCodeValue, bFormOptions);
            }


        });

        function getActualTicketFormHeader(count)
        {
            let sqrt = ' Билет'
            let selectedCount = getSelectedTicketsCount();
            if (selectedCount === 0) {
                return sqrt + 'ы';
            }

            switch(+count) {
                case 1 : {
                    return count + sqrt;
                }
                case 2: case 3: case 4 : {
                    return count + sqrt + 'а';
                }
            }

            if (selectedCount > 4) {
                return count + sqrt + 'ов';
            }
        }

        $form.on('change', '.payment-option__radio', function () {
            var promoCodeValue = $form.find('.promoCode-input').val();
            var paymentOptionCode = $(this).val();
            var paymentOptionFound = bFormOptions.payment.filter(obj => {
                return obj.code === paymentOptionCode
            })[0];

            if (paymentOptionFound && paymentOptionFound.warning) {
                $form.find('.payment-option-warning-wrap').html($(buyModule.renderPaymentOptionWarning(paymentOptionFound)));
            } else {
                $form.find('.payment-option-warning-wrap').html('');
            }

            buyModule.recalculatePriceMatrix($form, bFormPriceMatrix, promoCodeValue, bFormOptions);

            var $addressFieldsWrap = $form.find('.address-fields');
            if (paymentOptionFound && paymentOptionFound.requestAddress) {
                $addressFieldsWrap.html($(buyModule.renderAddressFields()));
            } else {
                $addressFieldsWrap.html('');
            }
        });

        $form.on('click', '.use-promo', function (e) {
            e.preventDefault();
            var promoCodeValue = $form.find('.promoCode-input').val();
            if (!promoCodeValue) {
                return false;
            }
            buyModule.recalculatePriceMatrix($form, bFormPriceMatrix, promoCodeValue, bFormOptions);
        });

        $form.on('click', '.delete-promo', function (e) {
            e.preventDefault();
            $form.find('.promoCode-input').val('');
            $form.find('.promoCode-input-hidden').val('');
            $form.find('.promoCode-input').removeClass('promoCode-input-active');

            buyModule.recalculatePriceMatrix($form, bFormPriceMatrix, false, bFormOptions);

            $form.find('.use-promo').show();
            $form.find('.delete-promo').hide();
        });
    },
    attachOnlineFormEventHandlers: function ($form, bFormOptions, bFormPriceMatrix) {
        bFormOptions = typeof bFormOptions !== 'undefined' ? bFormOptions : {};
        bFormPriceMatrix = typeof bFormPriceMatrix !== 'undefined' ? bFormPriceMatrix : {};

        $(document).on('submit', '.online-ticket__form', function (e) {
            e.preventDefault();

            const $form = $(this);

            app.setFormLoadingState($form, true);

            const method = $form.attr('method');
            const formData = $form.serialize();
            const endpoint = $form.attr('action');

            $.ajax({
                url: endpoint,
                method: method,
                data: formData,
                dataType: 'json',
            }).done(function (response) {
                switch (response.status) {
                    case 'success':
                        if (response.redirectUrl) {
                            location.href = response.redirectUrl;
                        } else if (response.cart) {
                            cartModule.updateHeaderCart(response.cart.count);

                            $form.find('.js-online-submit-cart-add').hide();
                            $form.find('.js-online-submit-pay-proceed').hide();
                            $form.find('.js-online-submit-stripe-pay-proceed').hide();
                            $form.find('.online-checkbox-group').hide();

                            $('.online-checkbox-group__course-members').css('display', 'none');
                            $form.find('.errors-container').html('');
                            $form.find('.js-online-already-cart').css('display', 'flex');
                            $form.find('.payment-system-container').css('display', 'none');
                            $form.find('.btn-pay-button-row').css('display', 'none');
                        }
                        break;
                    case 'error': {
                        ['giftCourseMemberSurname', 'giftCourseMemberName', 'giftCourseMemberEmail'].forEach(name => {
                            const $input = $(`input[name=${name}]`);
                            if ($input.length && !$input.val()) $input.css('borderColor', '#DE2551');
                        });
                        buyModule.setFormValidateErrors($form, response.errors);
                        break;
                    }
                }
            }).always(function (dataOrjqXHR, textStatus, jqXHRorError) {
                const resp = (textStatus === 'success') ? dataOrjqXHR : null;
                $form.trigger('onlineTicketForm:completed', [resp, textStatus]);

                app.setFormLoadingState($form, false);
            });
        });

        $(document).on('click', '.js-online-submit-cart-add', function (e) {
            e.preventDefault();
            if (app.isUserAuthorized()) {
                $form.attr('action', $form.attr('bFormCartAction'));
                app.buttonStartLoading(this);
                $form.find('.hidden-buyform-submit').click();
            } else {
                let formData = {
                    'onlineForm': $('.online-ticket__form').serialize(),
                };
                localStorage.setItem('online-buy-form-cart', JSON.stringify(formData));
                $('.online-ticket').hide();
                $('.inline-auth-holder').show().find('form').data('showafter', '.online-ticket');
                $('html, body').animate({
                    scrollTop: $('.sticky-container').offset().top - 150
                }, 500);
                e.stopPropagation();
            }
        });

        function actionForUnauthorizedUsers() {
            let formData = {
                'onlineForm': $('.online-ticket__form').serialize(),
            };
            localStorage.setItem('online-buy-form', JSON.stringify(formData));
            $('.online-ticket').hide();
            $('.inline-auth-holder').show().find('form').data('showafter', '.online-ticket');
            $('html, body').animate({
                scrollTop: $('.sticky-container').offset().top - 150
            }, 500);
        }

        $(document).on('change', '.payment-system-select', function () {
            let selectedValue = $(this).val();
            let lectureBuyerWidgetPaymentSystemAdditionalInfo = $('.lectureBuyerWidgetPaymentSystemAdditionalInfo');
            let payButton = $('.online-ticket__form .pay-button');

            lectureBuyerWidgetPaymentSystemAdditionalInfo.css('display', 'none');
            payButton.show();
            $('.errors-container').html('');

            if (selectedValue === 'platron') {
                payButton.removeClass('js-online-submit-stripe-pay-proceed').addClass('js-online-submit-pay-proceed');
                if (lectureBuyerWidgetPaymentSystemAdditionalInfo.hasClass('isCardRu')) {
                    lectureBuyerWidgetPaymentSystemAdditionalInfo.css('display', 'none');
                    payButton.show();
                }
            } else if (selectedValue === 'stripe') {
                payButton.removeClass('js-online-submit-pay-proceed').addClass('js-online-submit-stripe-pay-proceed');
                if (lectureBuyerWidgetPaymentSystemAdditionalInfo.hasClass('isCardEu')) {
                    lectureBuyerWidgetPaymentSystemAdditionalInfo.css('display', 'block');
                    payButton.hide();
                }
            }
        });

        $(document).on('click', '.js-online-submit-stripe-pay-proceed', function (e) {
            e.preventDefault();

            const $btn = $(this);

            document.querySelectorAll('.isStripe').forEach(function (element) {
                element.value = 1;
            });

            if (app.isUserAuthorized()) {
                $form.attr('action', $form.attr('bFormPayAction'));
                app.buttonStartLoading(this);
                $('.js-online-submit-cart-add').addClass('btn-disabled');

                $form.data('loadingButton', $btn[0]);

                $form.one('onlineTicketForm:completed', function (e, response) {
                    const btn = $form.data('loadingButton');
                    if (btn) {
                        app.buttonStopLoading(btn);
                        $form.removeData('loadingButton');
                    }
                });

                $form.find('.hidden-buyform-submit').click();
            } else {
                actionForUnauthorizedUsers();
            }
        });

        $(document).on('click', '.js-online-submit-pay-proceed', function (e) {
            e.preventDefault();

            const $btn = $(this);

            let paymentSystemSelect = $('.payment-system-select');
            if (paymentSystemSelect.length && paymentSystemSelect.val() === null) {
                let error = [];
                error['message'] = 'Пожалуйста, выберите способ оплаты';

                buyModule.setFormValidateErrors($form, [error]);

                return;
            }

            document.querySelectorAll('.isStripe').forEach(function (element) {
                element.value = 0;
            });

            if (app.isUserAuthorized()) {
                $form.attr('action', $form.attr('bFormPayAction'));
                app.buttonStartLoading(this);
                $('.js-online-submit-cart-add').addClass('btn-disabled');

                $form.data('loadingButton', $btn[0]);

                $form.one('onlineTicketForm:completed', function (e, response) {
                    const btn = $form.data('loadingButton');
                    if (btn) {
                        app.buttonStopLoading(btn);
                        $form.removeData('loadingButton');
                    }
                });

                $form.find('.hidden-buyform-submit').click();
            } else {
                actionForUnauthorizedUsers();
            }
        });

        $form.on('click', '.use-promo', function (e) {
            e.preventDefault();
            var promoCodeValue = $form.find('.promoCode-input').val();
            if (!promoCodeValue) {
                return false;
            }
            buyModule.recalculatePriceMatrix($form, bFormPriceMatrix, promoCodeValue, bFormOptions);
        });

        $form.on('click', '.delete-promo', function (e) {
            e.preventDefault();
            $form.find('.promoCode-input').val('');
            $form.find('.promoCode-input-hidden').val('');
            $form.find('.promoCode-input').removeClass('promoCode-input-active');

            buyModule.recalculatePriceMatrix($form, bFormPriceMatrix, false, bFormOptions);

            $form.find('.use-promo').show();
            $form.find('.delete-promo').hide();
        });

        $form.on('change', '.buy-options-select__inform', function () {
            var promoCodeValue = $form.find('.promoCode-input').val();
            buyModule.recalculatePriceMatrix($form, bFormPriceMatrix, promoCodeValue, bFormOptions);
        });
    },
    applyPromoCode: function ($form, promoCodeValue) {
        promoCodeValue = typeof promoCodeValue !== 'undefined' ? promoCodeValue : '';
        $form.find('.promoCode-input-hidden').val(promoCodeValue);
        $form.find('.promocode-response-message').removeClass('.promocode-response-message--error').html('');
        $form.find('.promoCode-input').addClass('promoCode-input-active');

        $form.find('.use-promo').hide();
        $form.find('.delete-promo').show();
    },
    initOfflineBuyForm: function () {
        var $aForms = $('.offline-ticket__form');
        var phpLectureDetails = false;
        if ($aForms.length > 0) {
            if (typeof window.php != 'undefined' && window.php !== null) {
                phpLectureDetails = window.php.lectureDetails;
            }
            $aForms.each(function () {
                var $form = $(this);
                var bFormOptions = false;
                var bFormPriceMatrix = false;
                var initialStateVar = $form.attr('bFormInitState');
                var initialPriceMatrix = $form.attr('bFormPriceMatrix');
                if (initialStateVar) {
                    bFormOptions = window[initialStateVar];
                }

                if (bFormOptions === null) {
                    return;
                }

                if (initialPriceMatrix) {
                    bFormPriceMatrix = window[initialPriceMatrix];
                }

                var $ticketsCountSelectWrap = $form.find('.tickets-count-select-wrap');
                var $ticketsChoseCodSecWrap = $form.find('.tickets-chose-cod-sec-wrap');
                var $paymentsWrapper = $form.find('.payment-options-wrap');
                var $priceMatrixWrap = $form.find('.priceMatrixWrap');
                var $pricesStrAllSumWrapper = $form.find('.pricesStrAllSumWrapper');
                if (bFormOptions.buyUrl) {
                    $('.go-to-offline-ticket-form').data('buyurl', bFormOptions.buyUrl);
                }

                $form.attr('action', $form.attr('bFormPayAction'));
                $form.data('placement', bFormOptions.placement);
                $form.data('type', bFormOptions.item?.type);
                $form.data('itemId', bFormOptions.item?.id);

                var itemType = bFormOptions.item?.type;
                var isAskAge = bFormOptions.isAskAge;

                if (typeof isAskAge === 'undefined') {
                    isAskAge = false;
                }

                if (bFormOptions?.choseSectorSelectionWithFreeSeating?.isChoseSectorSelectionWithFreeSeating === true) {
                    var uniqueSec = bFormOptions?.choseSectorSelectionWithFreeSeating?.uniqueSec;
                    if (uniqueSec && Object.keys(uniqueSec).length > 0) {
                        $ticketsChoseCodSecWrap.html($(buyModule.renderTicketsChoseCodSec(bFormOptions)))
                    } else {
                        $ticketsCountSelectWrap.html($(buyModule.renderTicketsCountSelect(bFormOptions)));
                    }
                } else {
                    $ticketsCountSelectWrap.html($(buyModule.renderTicketsCountSelect(bFormOptions)));
                }

                if (isAskAge) {
                    $form.find('.tickets-are-gift-checkbox__wrap').hide();
                    var $membersWrap = $form.find('.event-info-aside__buy-ticket__members-wrapper');
                    var ticketsCount = $ticketsCountSelectWrap.find('select').val();

                    for (i = 1; i <= ticketsCount; i++) {
                        $membersWrap.append($(buyModule.renderMemberCard(i, bFormOptions.placement === 'choice', isAskAge, false, bFormOptions.courseMemberFields)));
                    }
                    app.initNewPhoneInput();
                }

                $form.find('.places-badge-status').text(bFormOptions.placesBadgeStatus);

                if (bFormOptions.placement == 'choice') {
                    //$ticketsCountSelectWrap.after($(buyModule.renderPlaceChoiceBtn()));
                    $ticketsCountSelectWrap.hide();
                    drawHallScheme();
                }

                if (bFormOptions.payment) {
                    bFormOptions.payment.forEach((payment) => {
                        $paymentsWrapper.append($(buyModule.renderPaymentOption(payment)));
                    });
                }

                if (!bFormOptions.allowPromocode) {
                    $('.event-info-aside__buy-ticket___promo-code').remove();
                }

                // Для новой системы секторов устанавливаем начальную цену в 0, если билеты не выбраны
                if (bFormOptions && bFormOptions.usesSectorSystem && bFormOptions.choseSectorSelectionWithFreeSeating && bFormOptions.choseSectorSelectionWithFreeSeating.isChoseSectorSelectionWithFreeSeating === true) {
                    // Проверяем, выбраны ли билеты
                    var hasSelectedTickets = false;
                    if ($ticketsChoseCodSecWrap.length > 0) {
                        $ticketsChoseCodSecWrap.find('select').each(function() {
                            if (parseInt($(this).val()) > 0) {
                                hasSelectedTickets = true;
                                return false; // break
                            }
                        });
                    }
                    
                    // Если билеты не выбраны, устанавливаем цену в 0
                    if (!hasSelectedTickets && bFormPriceMatrix) {
                        var initialPriceMatrix = Object.assign({}, bFormPriceMatrix);
                        initialPriceMatrix.finalPrice = 0;
                        initialPriceMatrix.originalPrice = 0;
                        initialPriceMatrix.marginCost = 0;
                        initialPriceMatrix.originalMarginCost = 0;
                        initialPriceMatrix.promoDiscount = 0;
                        initialPriceMatrix.itemCount = 0;
                        bFormPriceMatrix = initialPriceMatrix;
                    }
                }
                
                let priceMatrix = $(buyModule.renderPriceMatrix(bFormPriceMatrix, $form, bFormOptions, itemType));

                if (priceMatrix && typeof priceMatrix === 'object' && priceMatrix.length > 0) {
                    $priceMatrixWrap.html(priceMatrix[0].pricesStr);
                    $pricesStrAllSumWrapper.html(priceMatrix[0].pricesStrAllSum);
                } else {
                    $priceMatrixWrap.css('display', 'none');
                    $pricesStrAllSumWrapper.css('display', 'none');
                }


                $('.offline-checkbox-group > div input[type=checkbox]').change(function() {
                    $(this).closest('label').addClass('checked-label');
                    const giftWarning = $('.are-gift-warn');

                    if ($(this).data('for') === 'isGift1') {
                        giftWarning.css('display', 'block');
                        $('.tickets-are-gift-checkbox').prop('checked', true);
                        $('.gift-warning-link').show();
                        $('#isGift1').prop('checked', true);
                        $('#isGift0').prop('checked', false);
                    } else {
                        giftWarning.hide();
                        $('.tickets-are-gift-checkbox').prop('checked', false);
                        $('#isGift1').prop('checked', false);
                        $('#isGift0').prop('checked', true);
                        $('.gift-warning-link').hide();
                    }

                    if ($(this).is(':checked')) {
                        $('.offline-checkbox-group > div input[type=checkbox]').not(this).prop('checked', false);
                        $('.offline-checkbox-group > div input[type=checkbox]').not(this).closest('label').removeClass('checked-label');
                    }

                    app.reCheckSticky();
                });

                buyModule.subscribeOnOfflineFormValidation($form);
                buyModule.attachEventHandlers($form, bFormOptions, bFormPriceMatrix);
            });
        }

        $(document).on('click', '.doAuthFake', function (e) {
            e.preventDefault();
            var modalParent = $(this).closest('.custom-dropdown');
            modalParent.find('.close-form').trigger('click');
        });
    },
    renderOfertaCheckbox: function () {
        return '<label><input class="uk-checkbox" id="offerAgreement" required name="offerAgreement" value="1" type="checkbox" checked>Согласен с публичной офертой</label>';
    },
    renderBuyOptions: function (buyOptions, wrap) {
        wrap = typeof wrap !== 'undefined' ? wrap : true;
        var buyOptionsStr = '';
        if (wrap) {
            buyOptionsStr += '<div class="event-info-aside__buy-ticket__input-group buy-options-select-wrap uk-clearfix">\n' +
                '                                        <header><h3 class="">Онлайн-трансляция</h3></header>\n';
        }
        buyOptionsStr += '<div class="custom-select-wrapper">\n' +
            '                                            <select class="custom-select buy-options-select__inform">\n';
        buyOptions.forEach((buyOption) => {
            buyOptionsStr += '<option value="' + buyOption.code + '">' + buyOption.title + '</option>';
        });

        buyOptionsStr += '</select>\n' +
            '                                        </div>\n';
        if (wrap) {
            buyOptionsStr += '</div>';
        }


        return buyOptionsStr;
    },
    validateOfflineForm: function ($form, selectedPlacesArray, bFormOptions) {
        var $errorsContainer = $form.find('.errors-container');
        $errorsContainer.html('');
        var $ticketsCountSelectWrap = $form.find('.tickets-count-select-wrap');
        var ticketsCount = $ticketsCountSelectWrap.find('select').val();

        var errors = [];

        if (bFormOptions.placement == 'choice' && ticketsCount > selectedPlacesArray.length) {
            errors.push({
                key: 'selected_items',
                message: 'Не выбраны места'
            });
        }

        return errors;
    },
    setFormValidateErrors: function ($form, errors) {
        var $errorsContainer = $form.find('.errors-container');
        $errorsContainer.html('');

        errors.forEach((error) => {
            $errorsContainer.append($(buyModule.renderErrorMsg(error.message)));
        });
    },
    renderErrorMsg: function (errorMsg) {
        return '<span class="__font-weight-300 error">' + errorMsg + '</span>';
    },
    initOnlineBuyForm: function () {
        var $oForm = $('.online-ticket__form');

        if ($oForm.length == 0) {
            return false;
        }

        if (window.location.hash === '#card') {
            $('.online-ticket').css('display', 'block');
            $('.event-info-aside__card').css('display', 'none');
        }

        var $priceMatrixWrap = $oForm.find('.priceMatrixWrap');
        var $pricesStrAllSumWrapper = $oForm.find('.pricesStrAllSumWrapper');
        var oFormOptions = false;
        var oFormPriceMatrix = false;
        var oInitialStateVar = $oForm.attr('bFormInitState');
        var oInitialPriceMatrix = $oForm.attr('bFormPriceMatrix');
        var activePromoCodeName = $oForm.attr('activePromoCodeName');

        if (localStorage.getItem('online-buy-form-cart')) {
            let onlineBuyFormCartData = JSON.parse(localStorage.getItem('online-buy-form-cart'));
            const params = new URLSearchParams(onlineBuyFormCartData.onlineForm);
            const promoCode = params.get('promoCode');

            if (promoCode) {
                activePromoCodeName = promoCode;
            }
        }

        if (oInitialStateVar) {
            oFormOptions = window[oInitialStateVar];
        }

        if (oInitialPriceMatrix) {
            oFormPriceMatrix = window[oInitialPriceMatrix];
        }

        if (oFormOptions.item.buyOptions && oFormOptions.item.buyOptions.length > 0) {
            $oForm.find('.buy-options__wrap').html($(buyModule.renderBuyOptions(oFormOptions.item.buyOptions, true)));
            if ($('.event-info-aside__buy-options').length > 0) {
                $('.event-info-aside__buy-options').html($(buyModule.renderBuyOptions(oFormOptions.item.buyOptions, false)));
            }
        }

        if (oFormOptions.buyUrl) {
            $('.go-to-online-ticket-form').data('buyurl', oFormOptions.buyUrl);
        }

        $oForm.attr('action', $oForm.attr('bFormPayAction'));
        $oForm.data('type', oFormOptions.item.type);
        $oForm.data('itemId', oFormOptions.item.id);

        var itemType = oFormOptions.item.type;

        buyModule.attachOnlineFormEventHandlers($oForm, oFormOptions, oFormPriceMatrix);

        let priceMatrix = $(buyModule.renderPriceMatrix(oFormPriceMatrix, $oForm, oFormOptions, itemType));

        $priceMatrixWrap.html(priceMatrix[0].pricesStr);
        $pricesStrAllSumWrapper.html(priceMatrix[0].pricesStrAllSum);

        if (activePromoCodeName) {
            buyModule.recalculatePriceMatrix($oForm, oFormPriceMatrix, activePromoCodeName, oFormOptions);
            $('.promoCode-input').val(activePromoCodeName);
        }

        if ($('.online-checkbox-group > div input[type=checkbox]').data('for') === 'isGift1') {
            const courseGiftMember = $('.online-checkbox-group__course-members');

            $('.online-checkbox-group__gift-warning').css('display', 'block');

            if (typeof courseGiftMember !== 'undefined') {
                courseGiftMember.find('input').removeAttr('disabled');
                courseGiftMember.show();
            }

            app.reCheckSticky();
        }

        $(('.online-checkbox-group > div input[type=checkbox]')).change(function() {
            $(this).closest('label').addClass('checked-label');
            const courseGiftMember = $('.online-checkbox-group__course-members');

            if ($(this).data('for') === 'isGift1') {
                $('.online-checkbox-group__gift-warning').css('display', 'block');

                if (typeof courseGiftMember !== 'undefined') {
                    courseGiftMember.find('input').removeAttr('disabled');
                    courseGiftMember.show();
                }
                $('#isGift1').prop('checked', true);
                $('#isGift0').prop('checked', false);
            } else {
                $('.online-checkbox-group__gift-warning').hide();

                if (typeof courseGiftMember !== 'undefined') {
                    courseGiftMember.find('input').removeAttr('required').attr('disabled', 'disabled');
                    courseGiftMember.hide();
                }

                $('#isGift1').prop('checked', false);
                $('#isGift0').prop('checked', true);
            }

            if ($(this).is(':checked')) {
                $(('.online-checkbox-group > div input[type=checkbox]')).not(this).prop('checked', false);
                $(('.online-checkbox-group > div input[type=checkbox]')).not(this).closest('label').removeClass('checked-label');
            }

            app.reCheckSticky();
        });

        // TODO It is possible to choose both options at the same time (GIFT)
        // $('.online-checkbox-group > div input[type=checkbox]').change(function () {
        //     if ($(this).prop('checked')) {
        //         $(this).closest('label').addClass('checked-label');
        //         $('#' + $(this).data('for')).prop('checked', true);
        //         var promoCodeValue = $oForm.find('#promoCodeName').val();
        //
        //         buyModule.recalculatePriceMatrix($oForm, oFormPriceMatrix, promoCodeValue, oFormOptions);
        //
        //         if ($(this).data('for') === 'isGift1') {
        //             const courseGiftMember = $('.online-checkbox-group__course-members');
        //
        //             $('.online-checkbox-group__gift-warning').css('display', 'block');
        //
        //             if (typeof courseGiftMember !== 'undefined') {
        //                 courseGiftMember.find('input').removeAttr('disabled');
        //                 courseGiftMember.show();
        //             }
        //             app.reCheckSticky();
        //         }
        //
        //         if ($('.online-checkbox-group > div label.checked-label').length === 2) {
        //             $('.new-translation-form__little-label.access-count').text('за 2 доступа');
        //         }
        //     } else {
        //         if ($('.online-checkbox-group > div label.checked-label').length === 2) {
        //             $(this).closest('label').removeClass('checked-label');
        //             $('#' + $(this).data('for')).prop('checked', false);
        //             var promoCodeValue = $oForm.find('#promoCodeName').val();
        //
        //             buyModule.recalculatePriceMatrix($oForm, oFormPriceMatrix, promoCodeValue, oFormOptions);
        //
        //             if ($(this).data('for') === 'isGift1') {
        //                 const courseGiftMember = $('.online-checkbox-group__course-members');
        //
        //                 $('.online-checkbox-group__gift-warning').hide();
        //
        //                 if (typeof courseGiftMember !== 'undefined') {
        //                     courseGiftMember.find('input').removeAttr('required').attr('disabled', 'disabled');
        //                     courseGiftMember.hide();
        //                 }
        //                 app.reCheckSticky();
        //             }
        //             $('.new-translation-form__little-label.access-count').text('за 1 доступ');
        //         }
        //     }
        // });
    },
    getPromoCodeValue: function () {
        let promoCodeInput = document.querySelector('#promoCodeName');
        let promoCodeValue = null;
        if (promoCodeInput) {
            promoCodeValue = promoCodeInput.value;
        }

        return promoCodeValue;
    },
    initFormOpeners: function () {
        $(document).on('click', '.go-to-offline-ticket-form', function () {
            if ($(this).closest('.sticky-element').length > 0) {
                $('html, body').animate({
                    scrollTop: $('#right-block-anchor').offset().top
                }, 500);
            }

            if ($('.event-info-aside__buy-ticket__member').length > 0 && !app.isUserAuthorized()) {
                $('.event-info-aside__card').hide();
                $('.inline-auth-holder').show().find('form').data('showafter', '.online-ticket');
                $('html, body').animate({
                    scrollTop: $('.sticky-container').offset().top - 150
                }, 500);

                let storageObject = {
                    url: $(location).attr('href'),
                    isShowGoToOfflineTicketForm: true
                };

                localStorage.setItem(app.localStorageGoToOfflineTicketFormKey, JSON.stringify(storageObject));

                return ;
            }

            let lectureId = $(this).attr('data-lectureId');

            if ($(this).data('buyurl')) {
                location.href = $(this).data('buyurl');
                return true;
            }
            $('.tickets-count-select-wrap select').trigger('change');
            $('.tickets-chose-cod-sec-wrap select').trigger('change');
            $('.event-info-aside__card').hide();

            var initialStateVar = $('.offline-ticket__form').attr('bFormInitState');
            if (initialStateVar) {
                if (window[initialStateVar].placement === 'choice') {
                    const placesContainer = $('.tickets-choose-container');
                    let priceBadges = $('#hallPricesVariants > span');

                    if (app.isMobile()) {
                        placesContainer.appendTo('.main-content__left-side');
                        placesContainer.css('marginBottom', '1em');
                        priceBadges.css('width', 100 / priceBadges.length + '%');
                        priceBadges.css('marginRight', '.2em');

                        if (!$('.main-content__left-side .mobile-price-variants').length) {
                            let mobilePriceVariantsContainer = document.createElement('div');
                            mobilePriceVariantsContainer.classList.add('mobile-price-variants');
                            placesContainer.before(mobilePriceVariantsContainer);
                            $('#hallPricesVariants').appendTo('.mobile-price-variants');
                        }
                        $('.mobile-price-variants').fadeIn();

                        if (!$('.main-content__left-side .mobile-chosen-tickets').length) {
                            let mobileChoosenTicketsContainer = document.createElement('div');
                            mobileChoosenTicketsContainer.classList.add('mobile-chosen-tickets');
                            placesContainer.after(mobileChoosenTicketsContainer);
                            $('.chosen-tickets-container').css('position', 'relative');
                            $('.chosen-tickets-container').appendTo('.mobile-chosen-tickets');
                        } else {
                            $('.tickets-choose-container').after($('.mobile-chosen-tickets'));
                            if ($('.mobile-chosen-tickets .chosen-tickets-container').html() !== '') {
                                $('.mobile-chosen-tickets').fadeIn();
                            }
                        }
                    } else {
                        placesContainer.prependTo('.main-content__left-side');
                        placesContainer.css('marginBottom', '0');
                        priceBadges.css('width', 'auto');
                        priceBadges.css('marginRight', '10px');

                        $('html, body').animate({
                            scrollTop: placesContainer.offset().top + 450
                        }, 300);
                    }

                    placesContainer.fadeIn();

                    if ($('.video-block').length) {
                        $('.video-block').fadeOut();
                    }
                }
            }

            $('.offline-ticket').show();
            app.reCheckSticky();
        });
        $(document).on('click', '.go-to-online-ticket-form', function (event) {
            if ($(this).closest('.sticky-element').length > 0) {
                $('html, body').animate({
                    scrollTop: $('#right-block-anchor').offset().top
                }, 500);
            }

            let lectureId = $(this).attr('data-lectureId');
            let getInCourse = $('.getInCourse').length;

            if (lectureId && getInCourse === 0) {
                app.countClickBuyerButton(lectureId, 'translation')
            }

            if ($(this).data('buyurl')) {
                location.href = $(this).data('buyurl');
                return true;
            }
            $('.event-info-aside__card').hide();

            $('.online-ticket').show();
            app.reCheckSticky();

            if ($(this).closest('form').hasClass('open-promo-cod-field')) {
                $('.event-info-aside__buy-ticket___promo-code').addClass('display-none');
            }
        });

        $(document).on('click', '.go-to-subscription', function (e) {
            e.preventDefault();

            if (!app.isUserAuthorized()) {
                let authHolder = $('.inline-auth-holder');
                $('.event-info-aside__card').hide();
                authHolder.show();
                $('html, body').animate({
                    scrollTop: authHolder.offset().top - 100
                }, 300);
            } else {
                location.href = this.href;
                return true;
            }

        });

        $(document).on('click', '#buy-single-event-subscription', function (e) {
            e.preventDefault();

            let lectureId = $(this).attr("data-lectureId");
            let stipeSingleEventSubscribe = $('#stipe-single-event-subscribe');

            if (stipeSingleEventSubscribe.is(':checked')) {
                let paymentSystemType = stipeSingleEventSubscribe.attr('data-payemntType')
                window.location.href = `/subscription-purchase/purchase-single-event?lectureId=${lectureId}&paymentSystem=${paymentSystemType}`;
            } else {
                window.location.href = `/subscription-purchase/purchase-single-event?lectureId=${lectureId}`;
            }

        });

        $(document).on('click', '.event-info-aside__buy-ticket__back-to-card a', function (e) {
            e.preventDefault();
            $('.online-ticket, .offline-ticket, .inline-auth-holder').hide();
            $('.event-info-aside__card').show();
            $('.tickets-choose-container').fadeOut();
            $('.mobile-chosen-tickets').fadeOut();
            $('.mobile-price-variants').fadeOut();

            if ($('.video-block').length) {
                $('.video-block').fadeIn();
            }

            app.reCheckSticky();
        });

        $(document).on('click', 'header.priceMatrixSlide', function () {
            /*$('.priceMatrixWrap').slideToggle();
            $('header.priceMatrixSlide h3 span').toggleClass('opened');
            app.reCheckSticky();*/
        });
    },
    validateOfflineFormBeforeSubmit: function (initToggle = false, promo = false) {
        $(document).ready(() => {
            let nameInputs = $(`input[name$="[name]"]`)
            let lastnameInputs = $(`input[name$="[lastname]"]`)
            let emailInputs = $(`input[name$="[email]"]`)
            let phoneInputs = $(`input[name$="[phone]"]`)
            let birthdayInputs = $(`input[name$="[birthday]"]`)
            let streets = $(`input[name$="[street]"]`)
            let entrances = $(`input[name$="[entrance]"]`)
            let floors = $(`input[name$="[floor]"]`)
            let flats = $(`input[name$="[flat]"]`)
            let promoInput = $('.custom-input.promoCode-input');

            let tickets = {
                nameInputs,
                lastnameInputs,
                emailInputs,
                phoneInputs,
                birthdayInputs,
                streets,
                entrances,
                floors,
                flats,
                promoInput
            }

            let toggleClass = (tickets) => {
                for (let i = 0; i < tickets.nameInputs.length; i++) {
                    !$(tickets.nameInputs[i]).val() ? $(tickets.nameInputs[i]).addClass('offline-validation__error') : $(tickets.nameInputs[i]).removeClass('offline-validation__error')
                }
                for (let i = 0; i < tickets.lastnameInputs.length; i++) {
                    !$(tickets.lastnameInputs[i]).val() ? $(tickets.lastnameInputs[i]).addClass('offline-validation__error') : $(tickets.lastnameInputs[i]).removeClass('offline-validation__error')
                }
                for (let i = 0; i < tickets.emailInputs.length; i++) {
                    !validateEmail($(tickets.emailInputs[i]).val()) ? $(tickets.emailInputs[i]).addClass('offline-validation__error') : $(tickets.emailInputs[i]).removeClass('offline-validation__error')
                }
                for (let i = 0; i < tickets.phoneInputs.length; i++) {
                    !validatePhone($(tickets.phoneInputs[i]).val()) ? $(tickets.phoneInputs[i]).addClass('offline-validation__error') : $(tickets.phoneInputs[i]).removeClass('offline-validation__error')
                }
                for (let i = 0; i < tickets.birthdayInputs.length; i++) {
                    !$(tickets.birthdayInputs[i]).val() ? $(tickets.birthdayInputs[i]).addClass('offline-validation__error') : $(tickets.birthdayInputs[i]).removeClass('offline-validation__error')

                    let $aForms = $('.offline-ticket__form');
                    if ($(tickets.birthdayInputs[i]).hasClass('offline-validation__error') === false) {
                        $aForms.each(function () {
                            let $form = $(this);
                            let $errorsContainer = $form.find('.errors-container');

                            $errorsContainer.html('');
                        })
                    } else {
                        $aForms.each(function () {
                            let $form = $(this);
                            let error = [];
                            error['message'] = 'Пожалуйста, заполните все поля';

                            buyModule.setFormValidateErrors($form, [error]);
                            app.reCheckSticky();
                        });
                    }
                }
                for (let i = 0; i < tickets.streets.length; i++) {
                    !$(tickets.streets[i]).val() ? $(tickets.streets[i]).addClass('offline-validation__error') : $(tickets.streets[i]).removeClass('offline-validation__error')
                }
                for (let i = 0; i < tickets.entrances.length; i++) {
                    !$(tickets.entrances[i]).val() ? $(tickets.entrances[i]).addClass('offline-validation__error') : $(tickets.entrances[i]).removeClass('offline-validation__error')
                }
                for (let i = 0; i < tickets.floors.length; i++) {
                    !$(tickets.floors[i]).val() ? $(tickets.floors[i]).addClass('offline-validation__error') : $(tickets.floors[i]).removeClass('offline-validation__error')
                }
                for (let i = 0; i < tickets.flats.length; i++) {
                    !$(tickets.flats[i]).val() ? $(tickets.flats[i]).addClass('offline-validation__error') : $(tickets.flats[i]).removeClass('offline-validation__error')
                }
                if (promo){
                    !$(tickets.promoInput).val() ? $(tickets.promoInput).addClass('offline-validation__error') : $(tickets.promoInput).removeClass('offline-validation__error')
                }
            }


            for (let i = 0; i < tickets.nameInputs.length; i++) {
                $(tickets.nameInputs[i]).on('input focusout', () => {
                    toggleClass(tickets);
                })
            }
            for (let i = 0; i < tickets.lastnameInputs.length; i++) {
                $(tickets.lastnameInputs[i]).on('input focusout', () => {
                    toggleClass(tickets);
                })
            }
            for (let i = 0; i < tickets.emailInputs.length; i++) {
                $(tickets.emailInputs[i]).on('input focusout', () => {
                    toggleClass(tickets);
                })
            }
            for (let i = 0; i < tickets.phoneInputs.length; i++) {
                $(tickets.phoneInputs[i]).on('input focusout', () => {
                    toggleClass(tickets);
                })
            }
            for (let i = 0; i < tickets.birthdayInputs.length; i++) {
                $(tickets.birthdayInputs[i]).on('input focusout', () => {
                    toggleClass(tickets);
                })
            }
            for (let i = 0; i < tickets.streets.length; i++) {
                $(tickets.streets[i]).on('input focusout', () => {
                    toggleClass(tickets);
                })
            }
            for (let i = 0; i < tickets.entrances.length; i++) {
                $(tickets.entrances[i]).on('input focusout', () => {
                    toggleClass(tickets);
                })
            }
            for (let i = 0; i < tickets.floors.length; i++) {
                $(tickets.floors[i]).on('input focusout', () => {
                    toggleClass(tickets);
                })
            }
            for (let i = 0; i < tickets.flats.length; i++) {
                $(tickets.flats[i]).on('input focusout', () => {
                    toggleClass(tickets);
                })
            }

            if ($('.offline-validation__error').length) {
                $('html, body').animate({
                    scrollTop: $('.offline-validation__error').offset().top - 150
                }, 600);
            }

            $(tickets.promoInput).on('input focusout', () => {
                toggleClass(tickets);
            })
            if (initToggle) {
                toggleClass(tickets);
            }

            let covidFreeCheckbox = $('#covid-free-checkbox');
            if (covidFreeCheckbox.length) {
                if (covidFreeCheckbox.prop('checked') === false) {
                    covidFreeCheckbox.addClass('offline-validation__error');
                    covidFreeCheckbox[0].setCustomValidity('Пожалуйста, ознакомьтесь и примите условия COVID-FREE');
                    covidFreeCheckbox[0].reportValidity();
                } else {
                    covidFreeCheckbox.removeClass('offline-validation__error');
                    covidFreeCheckbox[0].setCustomValidity('');
                }
            }

            $(document).on('click', '#covid-free-checkbox', function (e) {
                $('#covid-free-checkbox').removeClass('offline-validation__error');
                covidFreeCheckbox[0].setCustomValidity('');
            })

            let courseOfertaCheckbox = $('#oferta-course-checkbox');
            if (courseOfertaCheckbox.length) {
                if (!courseOfertaCheckbox.is(':checked')) {
                    courseOfertaCheckbox.addClass('offline-validation__error');
                    courseOfertaCheckbox[0].setCustomValidity( 'Пожалуйста, ознакомьтесь и примите условия договора Оферты Курса');
                    courseOfertaCheckbox[0].reportValidity();
                } else {
                    courseOfertaCheckbox.removeClass('offline-validation__error');
                    courseOfertaCheckbox[0].setCustomValidity( '');
                }
            }

            $(document).on('click', '#oferta-course-checkbox', function (e) {
                $('#oferta-course-checkbox').removeClass('offline-validation__error')
                $('#oferta-course-checkbox')[0].setCustomValidity( '');
            });

            let offerAgreementInput = $('#offerAgreement');
            if (offerAgreementInput.prop('checked') === false) {
                offerAgreementInput.addClass('offline-validation__error')
            } else {
                offerAgreementInput.removeClass('offline-validation__error')
            }

            $(document).on('click', '#offerAgreement', function (e) {
                $('#offerAgreement').removeClass('offline-validation__error')
            })
        })

    },
    subscribeOnOfflineFormValidation: function ($form) {
        let $ticketsCountSelectWrap = $form.find('.tickets-count-select-wrap');
        let ticketSelectInput = $ticketsCountSelectWrap.find('select')
        $(ticketSelectInput[0]).on('input', () => {
            buyModule.validateOfflineFormBeforeSubmit();
        })

        let payButton = $('.btn.btn-primary.js-offline-submit-pay-proceed');
        $(payButton[0]).on('click', (e) => {
            $(document).ready(() => {
                if (app.isUserAuthorized()) {
                    let initToggle = true;
                    buyModule.validateOfflineFormBeforeSubmit(initToggle);
                } else {
                    buyModule.validateOfflineFormBeforeSubmit();
                    $('.event-info-aside__buy-ticket__members-wrapper').find('input').blur();
                    $('.promoCode-input').removeClass('offline-validation__error');

                    if (!$('.offline-validation__error').length
                        && !$('.error-member-info').length
                        && !$('.errors-container span').length
                    ) {
                        $('.offline-ticket').hide();
                        let formData = {
                            'lectureId': buyModule.currentLectureId(),
                            'selectedPlaces': getCheckedPlaces() ?? [],
                            'isTicketsGifts': $('.tickets-are-gift-checkbox').is(':checked'),
                            'offlineForm': $('.offline-ticket__form').serialize(),
                        };
                        localStorage.setItem('offline-buy-form', JSON.stringify(formData));
                        $('.inline-auth-holder').show().find('form').data('showafter', '.offline-ticket');
                        $('html, body').animate({
                            scrollTop: $('.sticky-container').offset().top - 150
                        }, 500);
                        e.stopPropagation();
                    }
                }
            })
        })

        let promoButton = $('.btn.btn-outline-secondary.event-info-aside__buy-ticket___promo-code__btn.use-promo');
        $(promoButton[0]).on('click', () => {
            $(document).ready(() => {
                let initToggle = true;
                let promo = true;
                buyModule.validateOfflineFormBeforeSubmit(initToggle,promo);
            })
        })

        let cardOnSiteInput = $('.uk-radio.payment-option__radio')[0]
        $(cardOnSiteInput).on('input', () => {
            buyModule.validateOfflineFormBeforeSubmit();
        })

        let cashOnCourier = $('.uk-radio.payment-option__radio')[1]
        $(cashOnCourier).on('input', () => {
            buyModule.validateOfflineFormBeforeSubmit();
        })

        let ticketInGiftInput = $('.uk-checkbox.tickets-are-gift-checkbox')[0]
        $(ticketInGiftInput).on('input', () => {
            buyModule.validateOfflineFormBeforeSubmit();
        })

        buyModule.validateOfflineFormBeforeSubmit();
    }

}

function generatePriceHTML (icon, text, price, oldPrice) {
    return `
        <div class="text-icon">
            ${createSvgIconHTML(icon)}
            <div class="uk-flex uk-flex-between uk-flex-middle uk-width-1-1">
                <div class="text-17 text-15-sm">
                    ${text}
                </div>
                <div class="h4">
                    ${price}
                </div>
            </div>
        </div>`;
}

function generateFinalPriceHTML (finalPrice, oldPrice, entityTitle) {
    return `
        <div class="event-info-aside__buy-ticket__price-total price-total">
            <div class="uk-flex uk-flex-bottom gap-8">
                <div class="final-price h3">
                    ${finalPrice}
                </div>
                ${oldPrice ? `
                    <div class="h5 text-dark-grey text-decoration-line-through">
                        ${oldPrice}
                    </div>` : ''}
            </div>
            <span>${entityTitle}</span>
        </div>`;
}

function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

function validatePhone(phone) {
    phone = phone.replace(/-/g, '');
    phone = phone.replace(/_/g, '');
    return phone.length >= 11
}

$.fn.deserialize = function (data) {
    var f = this,
        map = {},
        find = function (selector) { return f.is("form") ? f.find(selector) : f.filter(selector); };
    $.each(data.split("&"), function () {
        const nv = this.split("="),
            n = decodeURIComponent(nv[0]),
            v = nv.length > 1 ? decodeURIComponent(nv[1]) : null;
        if (!(n in map)) {
            map[n] = [];
        }
        map[n].push(v);
    })
    $.each(map, function (n, v) {
        find("[name='" + n + "']").val(v);
    })
    find("input:text,select,textarea").each(function () {
        if (!(jQuery(this).attr("name") in map)) {
            jQuery(this).val("");
        }
    })
    find("input:checkbox:checked,input:radio:checked").each(function () {
        if (!(jQuery(this).attr("name") in map)) {
            this.checked = false;
        }
    })
    return this;
};

$("document").ready(function () {
    buyModule.init();
});

document.addEventListener('DOMContentLoaded', () => {
    const hideable = document.querySelector('.event-info-aside__hideable-part');

    if (!hideable) {
        return;
    }

    const stickable = hideable.closest('.stickable');
    const card = hideable.closest('.event-info-aside__card');

    let bottomY = null;
    let ticking = false;
    let isStuck = false;

    const updateBottomY = () => {
        const rect = hideable.getBoundingClientRect();
        bottomY = rect.bottom + window.scrollY;
    };

    const isCardVisible = () => {
        return card && window.getComputedStyle(card).display !== 'none';
    };

    updateBottomY();
    window.addEventListener('resize', updateBottomY);

    const onScroll = () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                const scrollY = window.scrollY;

                if (stickable && isCardVisible() && window.innerWidth >= 1025) {
                    if (!isStuck && scrollY > bottomY) {
                        hideable.style.display = 'none';
                        stickable.classList.add('sticky-element');
                        isStuck = true;
                    } else if (isStuck && scrollY <= bottomY) {
                        hideable.style.display = 'block';
                        stickable.classList.remove('sticky-element');
                        isStuck = false;
                    }
                } else if (isStuck) {
                    hideable.style.display = 'block';
                    stickable.classList.remove('sticky-element');
                    isStuck = false;
                }

                ticking = false;
            });

            ticking = true;
        }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
});
